import axios from "axios";
import * as config from "../config";
import * as Services from "../../Service/Service"
import * as Url from '../../Service/Url';

export const getRegionDetail = async() => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_REGIONS_DATA, token)
  return res;
};

export const getClientsData = async(id) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_CLIENT_DATA_BY_UDID + id, token)
  return res;
};

export const getClientsDatabyPagination = async(UD_id,PageNumber) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_CLIENT_DATA_BY_UDID_BY_PAGE + `UD_id=${UD_id}&PageNumber=${PageNumber}&PageSize=100`, token)
  return res;
};

export const getClientsDatabyPaginationbySearch = async(UD_id,PageNumber,searchkey) => {
  const token = localStorage.getItem("token");
  function encodeForUrl(str) {
    const encoded = encodeURIComponent(str);
    const replacements = {
      ' ': '%20', // Space (already handled by encodeURIComponent)
      "'": '%27', // Apostrophe
      '&': '%26', // Ampersand
      '+': '%2B', // Plus sign
      ',': '%2C', // Comma
      '/': '%2F', // Forward slash
      ':': '%3A', // Colon
      ';': '%3B', // Semicolon
      '=': '%3D', // Equals sign
      '?': '%3F', // Question mark
      '@': '%40', // At sign
      '#': '%23', // Hash
      '%': '%25', // Percent sign (needs to be encoded manually)
    };
  
    return encoded.replace(/[-._~!^*()$]/g, (char) => replacements[char] || char);
  }
  
  const encodedString = encodeForUrl(searchkey);
  let res = await Services.GET(Url.GET_CLIENT_DATA_BY_UDID_BY_PAGE_BY_SEARCH + `UD_id=${UD_id}&PageNumber=${PageNumber}&PageSize=100&Search=${encodedString}`, token)
  return res;
};

export const getNotificationData = async(userId, NotifLoginUserStatus) => {
  let id = NotifLoginUserStatus === 1 ? 0 : userId;

  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_USER_NOTIFICATION + `NotifLoginUserStatus=${NotifLoginUserStatus}&NotifUserID=${id}`, token)
  return res;
};

export const clearNotification = async(payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.SAVE_NOTIFICATION_CLEAR_DATA, payload, token)
  return res;
};

export const GetFileTypeByCarrier = async(id) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_FILETYPE_CARRIER + id, token)
  return res;
};


export const getCategoryMasterData = async() => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_CATEGORY_MASTER, token)
  return res;
};

export const getFileTypeData = async() => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_FILE_TYPE_DATA, token)
  return res;
};

export const postClientsMedicalCarrierDataFileUpload = (
  clientId,
  carrierId,
  filetypeId,
  FileTypeName,
  fileUploadedBy,
  file
) => {
  const token = localStorage.getItem("token");
  const formData = new FormData();
  formData.append("file", file);

  let res = Services.POSTFORMDATA(
    `/api/MedicalCarrier/ClientsMedicalCarrierDataFileUpload?ClientID=${clientId}&CarrierID=${carrierId}&FileTypeID=${filetypeId}&FileUploadedBy=${fileUploadedBy}&FileTypeName=${FileTypeName}`,
    formData,
    token
  )
  return res;
};

export const GetAllEmpoweRxDrugDiscountWithPagination = async (
  userId,
  pageNum,
  pageSize,
  search
) => {
  const token = localStorage.getItem("token");
  let url;
  if (search) {
    url = Url.GET_ALL_EMPOWER_RX_DRUG_DISCOUNT + `userId=${userId}`  + `&PageNumber=${
      pageNum + 1
    }&PageSize=${pageSize}&Search=${search}`;
  } else {
    url = Url.GET_ALL_EMPOWER_RX_DRUG_DISCOUNT  + `userId=${userId}` +`&PageNumber=${
      pageNum + 1
    }&PageSize=${pageSize}`;
  }
  let res = await Services.GET(url, token);
  return res;
};

export const GetPBMList = async() => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_PBM , token)
  return res;
};

export const GetCarrierFileType = async() => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GETCARRIERFILETYPE , token)
  return res;
};